import React from 'react';
import { Select, SelectItem, Textarea } from 'ui/Input';
import FileField from 'ui/Input/UploadArea/FileField';
import { IAccount } from 'store/accounts.model';
import { IFormValues } from './FileUpload.model';

const renderSourceAccountField = (accounts: IAccount[], submitting: boolean) => (
  <Select name="sourceAccount" label="Source Account" disabled={submitting}>
    {accounts.map(({ accountNumber }) => (
      <SelectItem value={accountNumber} key={accountNumber}>
        {accountNumber}
      </SelectItem>
    ))}
  </Select>
);

const renderDestinationAccountField = (accounts: IAccount[], submitting: boolean) => (
  <Select name="destinationAccountNo" label="Destination Account" disabled={submitting}>
    {accounts.map(({ accountNumber }) => (
      <SelectItem value={accountNumber} key={accountNumber}>
        {accountNumber}
      </SelectItem>
    ))}
  </Select>
);

const renderNarrationField = (submitting: boolean) => (
  <Textarea name="narration" label="Narration" disabled={submitting} />
);

export const renderTransferFieldsFrom = (accounts: IAccount[], submitting: boolean) => (
  <>
    {renderSourceAccountField(accounts, submitting)}
  </>
);

export const renderBulkTransferUpload = (submitting: boolean) => (
  <>
    <FileField name="files" disabled={submitting} />
  </>
);

export const renderTransferFieldsTo = (accounts: IAccount[], values: IFormValues, submitting: boolean) => (
  <>
    {renderDestinationAccountField(
      accounts.filter(({ accountNumber }) => values?.sourceAccount !== accountNumber),
      submitting,
    )}
    {renderNarrationField(submitting)}
  </>
);
